var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b2b-container',{staticClass:"background-image",attrs:{"id":"loading","column":"","align-center":"","justify-center":""}},[_c('b2b-app-loading',{staticClass:"invitation__loading"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }